// extracted by mini-css-extract-plugin
export default {"toggle-wrapper":"ToggleButton_toggle-wrapper__2JwD9","switch":"ToggleButton_switch__dtDfA","slider":"ToggleButton_slider__MbEUw","round":"ToggleButton_round__SpD-4"};